<template>
  <div class="contratos">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado de contratos')">
        <el-row>
          <el-col :span="8">
            <el-form onsubmit="return false;" label-position="left">
              <el-form-item label="Búsqueda avanzada">
                <el-input
                  :placeholder="$t('Búsqueda por nombre de contrato')"
                  prefix-icon="el-icon-search"
                  v-model="search"
                  class="search"
                  size="medium"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <el-form onsubmit="return false;" label-position="left">
              <el-form-item label="Tipo de contrato">
                <el-select
                  class="tipoContrato"
                  size="medium"
                  v-model="tipo"
                  placeholder="Seleccione tipo"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="9">
            <el-button
              size="small"
              type="primary"
              class="right"
              @click="createContract()"
              icon="el-icon-edit"
            >{{$t('Nuevo Contrato')}}</el-button>
          </el-col>
        </el-row>
        <el-row
          element-loading-text="Cargando..."
          element-loading-background="rgba(255, 255, 255)"
          v-loading="loading"
        >
          <el-table
            :max-height="700"
            class="contractsTable"
            :data="paginar === false ? contracts: paginarContratos()"
            row-class-name="rowClassTablaPloma"
            cell-class-name="cellClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray"
          >
            <el-table-column :label="$t('Área')" min-width="150px" sortable>
              <template slot-scope="scope">
                <p v-if="scope.row.area_id">
                  {{getAreaByID(scope.row.area_id)}}
                  <i
                    class="el-icon-info info"
                    @click="openDialogInfoArea(scope.row.area_id)"
                  ></i>
                </p>
                <p v-else class="text-muted">{{$t('No asignada')}}</p>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tipo !== 'Propio'"
              :label="$t('Empresa')"
              min-width="150px"
              sortable
            >
              <template slot-scope="scope">
                <p v-if="scope.row.tipo_contrato === 'Propio'" class="text-muted">No aplica</p>
                <p v-else>{{ getEmpresaByID(scope.row.empresa_id) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              v-if="tipo === 'Subcontratista'"
              :label="$t('Empresa Subcontratista')"
              min-width="150px"
              sortable
            >
              <template slot-scope="scope">
                <p v-if="scope.row.tipo_contrato !== 'Subcontratista'" class="text-muted">No aplica</p>
                <p v-else>{{ getEmpresaByID(scope.row.empresa_subcontratista_id) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="nombre"
              min-width="170px"
              :label="$t('Nombre del contrato')"
              sortable
            />
            <el-table-column
              prop="numero_contrato"
              width="130px"
              :label="$t('N° Contrato')"
              sortable
            />
            <el-table-column width="120px" prop="tipo_contrato" :label="$t('Tipo')" sortable>
              <template slot-scope="scope">{{ scope.row.tipo_contrato }}</template>
            </el-table-column>
            <el-table-column width="100px" :label="$t('Estado')">
              <template slot-scope="scope">
                <span
                  :class="['safety-tag', isActiveContract(scope.row) ? 'green' : 'red']"
                >{{ isActiveContract(scope.row) ? $t('Vigente') : $t('Vencido') }}</span>
              </template>
            </el-table-column>
            <el-table-column width="110px">
              <template slot-scope="scope">
                <div class="ver" @click="elegirContrato(scope.row)">
                  <i class="el-icon-edit-outline"></i>
                  {{$t('Ver/Editar')}}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <br />
          <center>
            <el-pagination
              :current-page="page"
              @prev-click="backPage"
              @next-click="nextPage"
              @current-change="currentPage"
              :page-size="5"
              layout="prev, pager, next"
              :total="totalPage"
            ></el-pagination>
          </center>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!--Dialog editar-->
    <el-dialog
      top="3vh"
      :before-close="handleClose"
      :title="`Modificando Contrato`"
      :visible="editarVisible"
      width="65%"
    >
      <div class="content_edit">
        <ModificarContrato :contract="contract" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editarVisible = false">Cerrar</el-button>
        <el-button :loading="isLoading" @click="updateContract()" type="primary">Modificar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="getAreaByID(area_id)"
      :visible.sync="dialogInfoArea"
      width="30%"
      :before-close="handleClose"
    >
      <br />
      <div class="espacioTitulo">
        <b>Gerencia</b>
      </div>
      {{getGerencia(area_id)}}
      <br />
      <br />
      <div class="espacioTitulo">
        <b>Superintendencias</b>
      </div>
      <li
        style="list-style:none;"
        v-for="item in superintendencias"
        :key="item.nombre"
      >{{item.nombre}}</li>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInfoArea = false">Cerrar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import ModificarContrato from "@/components/EditarContrato.vue";
import axios from "axios";

export default {
  name: "Contracts",
  data() {
    return {
      dialogInfoArea: false,
      tipo: "Propio",
      options: [
        {
          value: "Propio",
          label: "Propio"
        },
        {
          value: "Contratista",
          label: "Contratista"
        }
      ],
      area_id: "",
      dialogVisible: false,
      editarVisible: false,
      isLoading: false,
      contracts: [],
      contract: {},
      contract_id: "",
      superintendencias: [],
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente de Área"),
        super: this.$t("Superintendente de Área"),
        general_manager: this.$t("Gerente General")
      },
      totalPage: 0,
      paginar: false,
      search: "",
      page: 1,
      loading: false
    };
  },
  components: {
    ModificarContrato
  },
  watch: {
    tipo: function() {
      this.page = 1;
      this.listadoContratos(this.page, this.search);
    },
    search: function() {
      this.loading = true;
      this.debounceInputSearch();
    }
  },
  computed: {
    ...mapGetters({
      usersFaena: "usersFaena",
      empresas: "empresas",
      areas: "areas"
    }),
    areaSuperintendent() {
      if (!this.area.super || !this.area.super.nombre) return "---";
      return `${this.area.super.nombre} ${this.area.super.apellido}`;
    },
    areaManager() {
      if (!this.area.gerente || !this.area.gerente.nombre) return "---";
      return `${this.area.gerente.nombre} ${this.area.gerente.apellido}`;
    },
    areaSuperiorManager() {
      if (!this.area.area_padre) return "---";
      if (!this.area.area_padre.gerente || !this.area.area_padre.gerente.nombre)
        return "---";
      return `${this.area.area_padre.gerente.nombre} ${this.area.area_padre.gerente.apellido}`;
    }
  },
  async created() {
    this.setTitle(this.$t("Administración de contratos"));
    this.setSubTitle(this.$t("Inventario de riesgos HSE online"));
    this.listadoContratos(1, this.search);
    await this.getAreasFaena();
    await this.getEmpresasFaena();
    await this.getUsersFaena(this.$store.getters.role.faena_id);
  },
  methods: {
    ...mapActions([
      "setTitle",
      "setSubTitle",
      "getUsersFaena",
      "getAreasFaena",
      "getEmpresasFaena",
      "saveContract"
    ]),
    debounceInputSearch: _.debounce(function() {
      this.page = 1;
      this.listadoContratos(this.page, this.search);
    }, 1200),
    listadoContratos(page, search) {
      this.loading = true;
      var self = this;
      axios
        .get(
          `/contratos/getAllContracts/${this.$store.getters.role.faena_id}/${
            this.tipo
          }/${page}/${search === "" ? undefined : search}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then(response => {
          self.contracts = response.data.results;
          self.totalPage = response.data.total;
          self.paginar = response.data.paginar;
          self.loading = false;
        });
    },
    paginarContratos() {
      return this.contracts.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoContratos(page, this.search);
    },
    openDialogInfoArea(area_id) {
      this.superintendencias = [];
      this.dialogInfoArea = true;
      this.area_id = area_id;
      this.areas.forEach(a => {
        this.superintendencias = this.areas.filter(
          as => as.area_padre_id && as.area_padre_id === area_id
        );
      });
      if (this.superintendencias.length === 0) {
        this.superintendencias.push({ nombre: "Sin Superintendencias" });
      }
    },
    getGerencia(area_id) {
      let area_padre = this.areas.find(x => x._id === area_id);
      if (area_padre && area_padre.area_padre_id) {
        return this.getAreaByID(area_padre.area_padre_id);
      } else {
        return "Sin Gerencia";
      }
    },
    getEmpresaByID(id) {
      let empresa = this.empresas.find(x => x._id === id);
      if (empresa) {
        return empresa.nombre;
      } else {
        return "Empresa no encontrada";
      }
    },
    getAreaByID(id) {
      let area = this.areas.find(x => x._id === id);
      if (area) {
        return area.nombre;
      } else {
        return "Área no encontrada";
      }
    },
    async updateContract() {
      this.isLoading = true;
      await this.saveEdit();
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") {
        return true;
      }
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    handleClose() {
      this.editarVisible = false;
      this.dialogInfoArea = false;
    },
    elegirContrato(contrato) {
      this.contract = JSON.parse(JSON.stringify(contrato));
      this.editarVisible = true;
    },
    createContract() {
      this.$router.push({ name: "contractCreateStep1" });
    },
    saveEdit() {
      const val = JSON.parse(JSON.stringify(this.contract));
      const id = this.contract._id;
      delete this.contract._id;
      this.$store
        .dispatch("editContract", {
          id,
          body: this.contract
        })
        .then(async response => {
          if (response.success) {
            this.listadoContratos(this.page, this.search);
            this.$notify.success({
              title: this.$t("Éxito"),
              message: this.$t("Contrato editado exitosamente")
            });
            this.editarVisible = false;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.$alert(response.message, this.$t("Atención"), {
              type: "error"
            });
          }
        });
    }
  }
};
</script>

<style scoped>
.ver {
  cursor: pointer;
}

.right {
  text-align: right;
}
.search {
  max-width: 340px;
}
.content {
  min-height: 50vh;
}
.content_edit {
  padding: 10px;
}
.info {
  cursor: pointer;
}
.espacioTitulo {
  margin-bottom: 5px;
}
</style>
